import { PropsWithChildren } from "react";
import { useParams } from "react-router";

const ProductLayout: React.FC<PropsWithChildren> = ({ children }) => {
    let { service } = useParams();

    return <div className={service !== 'iheartjane' ? "h-[100dvh]" : ""}>{children}</div>;
};

export default ProductLayout;
